import { ItemsProvider } from "@@contexts/ItemsContext";
import { DamageRecognitionProvider } from "@@pages/item-details/contexts/DamageRecognitionContext";
import { ItemDetailsProvider } from "@@pages/item-details/contexts/ItemDetailsContext";
import { ItemListProvider } from "@@pages/item-list/contexts/ItemListContext";
import LoadingSpinner from "@lux/ds/LoadingSpinner";
import Backdrop from "@mui/material/Backdrop";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const PageProductList = lazy(() => import("@@pages/item-list/ItemList"));
const PageProductDetails = lazy(
  () => import("@@pages/item-details/ItemDetails"),
);

const RouteInventory: React.FC = () => {
  return (
    <Suspense
      fallback={
        <Backdrop open={true} sx={{ zIndex: 99 }}>
          <LoadingSpinner />
        </Backdrop>
      }
    >
      <ItemsProvider>
        <Routes>
          <Route
            path='/'
            element={
              <ItemListProvider>
                <PageProductList />
              </ItemListProvider>
            }
          />
          <Route
            path='/:id'
            element={
              <ItemDetailsProvider>
                <DamageRecognitionProvider>
                  <PageProductDetails />
                </DamageRecognitionProvider>
              </ItemDetailsProvider>
            }
          />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </ItemsProvider>
    </Suspense>
  );
};

export default RouteInventory;
